import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.5 6.625V15.3033C17.5 16.102 16.87 16.75 16.0938 16.75H3.90625C3.13 16.75 2.5 16.1013 2.5 15.3033V4.696C2.5 3.89875 3.13 3.25 3.90625 3.25H8.59375L10.4688 5.17825H16.0938C16.87 5.17825 17.5 5.82625 17.5 6.625Z",
		fill: "#0D2976"
	})
});
export default SvgFolder;
